import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/sip-calculator")({
  component: SipCalculatorLayout,
});

function SipCalculatorLayout() {
  return <Outlet />;
}
